/* Ornamint v3 motion layer (sitewide, deferred). Its CSS rules are at the end of assets/ornamint-site.css (motion layer).
   Does nothing that hides content unless it is running: hidden start states need html.orn-io, which only this file adds. */
(function () {
  'use strict';
  var d = document, html = d.documentElement;
  var mq = function (q) { return window.matchMedia ? window.matchMedia(q) : { matches: false }; };
  var reduce = mq('(prefers-reduced-motion: reduce)').matches;
  var fine = mq('(hover: hover) and (pointer: fine)').matches;
  var sdt = !!(window.CSS && CSS.supports && CSS.supports('animation-timeline', 'view()') && CSS.supports('animation-timeline', 'scroll()'));
  var ORN = window.ORN = window.ORN || {};
  ORN.reduce = reduce;
  ORN.fine = fine;

  /* ---------- Intro preloader: skip on click / key / wheel / touch / scroll, always cleaned up ---------- */
  if (html.classList.contains('orn-intro-on')) {
    var introDone = function () { html.classList.remove('orn-intro-on', 'orn-intro-skip'); ['click', 'keydown', 'wheel', 'touchstart', 'scroll'].forEach(function (t) { window.removeEventListener(t, skip, true); }); };
    var skip = function () { if (!html.classList.contains('orn-intro-on')) return; html.classList.add('orn-intro-skip'); setTimeout(introDone, 260); };
    ['click', 'keydown', 'wheel', 'touchstart', 'scroll'].forEach(function (t) { window.addEventListener(t, skip, { capture: true, passive: true }); });
    setTimeout(introDone, 2100);
  }

  if (reduce) { html.classList.add('orn-reduce'); }

  /* ---------- Header: scrolled state + dropdown keyboard / Esc / outside-click handling ---------- */
  var scrolledTick = false;
  var setScrolled = function () { scrolledTick = false; html.classList.toggle('orn-scrolled', (window.scrollY || html.scrollTop) > 8); };
  window.addEventListener('scroll', function () { if (!scrolledTick) { scrolledTick = true; requestAnimationFrame(setScrolled); } }, { passive: true });
  setScrolled();
  function openTriggers() { return [].slice.call(d.querySelectorAll('.header [data-meganav-trigger][aria-expanded="true"]')); }
  function closeMenus(focusBack) {
    openTriggers().forEach(function (t) {
      var li = t.closest('li');
      ['mouseleave', 'mouseout'].forEach(function (n) { (li || t).dispatchEvent(new MouseEvent(n, { bubbles: true, relatedTarget: d.body })); });
      t.setAttribute('aria-expanded', 'false');
      var m = li && li.querySelector('.meganav');
      if (m) m.classList.remove('active');
      if (focusBack) {
        // The theme opens a dropdown when its trigger gains focus: swallow that one focus event while focus returns
        var swallow = function (ev) { ev.stopImmediatePropagation(); };
        window.addEventListener('focusin', swallow, true);
        window.addEventListener('focus', swallow, true);
        t.focus();
        setTimeout(function () { window.removeEventListener('focusin', swallow, true); window.removeEventListener('focus', swallow, true); }, 0);
      }
    });
    var h = d.querySelector('.header');
    if (h) h.classList.remove('dropdown-active');
  }
  function openMenu(t) {
    var li = t.closest('li');
    ['mouseenter', 'mouseover'].forEach(function (n) { (li || t).dispatchEvent(new MouseEvent(n, { bubbles: true })); });
    t.setAttribute('aria-expanded', 'true');
  }
  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openTriggers().length) { closeMenus(true); return; }
    var t = e.target instanceof Element && e.target.closest('.header [data-meganav-trigger]');
    if (t && (e.key === 'ArrowDown' || e.key === ' ')) {
      e.preventDefault();
      openMenu(t);
      // focus the first link once the panel is visible (it fades in)
      var tries = 0;
      var focusFirst = function () {
        var links = [].slice.call(t.closest('li').querySelectorAll('.meganav a')).filter(function (x) { return x.offsetParent !== null && getComputedStyle(x).visibility !== 'hidden'; });
        if (links.length) { links[0].focus(); if (d.activeElement === links[0]) return; }
        if (++tries < 10) setTimeout(focusFirst, 60);
      };
      setTimeout(focusFirst, 60);
    }
  });
  /* Mobile drawer: submenus open as accordions in place (instead of the theme's sliding panels) */
  d.addEventListener('click', function (e) {
    var p = e.target instanceof Element && e.target.closest('.drawer-menu a[data-item="parent"]');
    if (!p) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var li = p.closest('li'), sub = li && li.querySelector(':scope > .drawer-menu__list--sub');
    var open = !li.classList.contains('orn-acc-open');
    li.classList.toggle('orn-acc-open', open);
    p.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (sub) sub.setAttribute('aria-hidden', open ? 'false' : 'true');
  }, true);
  d.addEventListener('click', function (e) { if (openTriggers().length && !(e.target instanceof Element && e.target.closest('.header'))) closeMenus(false); }, true);
  d.addEventListener('focusin', function (e) { if (openTriggers().length && !(e.target instanceof Element && e.target.closest('.header'))) closeMenus(false); });

  /* ---------- Fallback for browsers without animation-timeline ---------- */
  var io = null;
  function reveal(el) { el.classList.add('is-in'); }
  ORN.observe = function (root) {
    if (!io) return;
    (root || d).querySelectorAll('[data-fx]:not(.is-in)').forEach(function (el) { io.observe(el); });
  };
  if (!reduce && !sdt) {
    html.classList.add('orn-no-sdt');
    if ('IntersectionObserver' in window) {
      html.classList.add('orn-io');
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -5% 0px', threshold: 0.01 });
      ORN.observe();
      // Anything already above the fold reveals immediately; a safety net reveals everything after 4 s
      var aboveFold = function () { d.querySelectorAll('[data-fx]:not(.is-in)').forEach(function (el) { if (el.getBoundingClientRect().top < window.innerHeight) reveal(el); }); };
      setTimeout(aboveFold, 50); setTimeout(aboveFold, 600); window.addEventListener('load', aboveFold);
      setTimeout(function () { d.querySelectorAll('[data-fx]:not(.is-in)').forEach(function (el) { if (el.getBoundingClientRect().bottom < 0) reveal(el); }); }, 4000);
    }
    // Scroll-linked variables: --orn-sp (page progress), --orn-hp (header morph 0..1 over 160px), --orn-p700 (hero parallax)
    var ticking = false;
    var update = function () {
      ticking = false;
      var y = window.scrollY || html.scrollTop, max = Math.max(1, html.scrollHeight - window.innerHeight);
      html.style.setProperty('--orn-sp', Math.min(1, y / max).toFixed(4));
      html.style.setProperty('--orn-hp', Math.min(1, y / 160).toFixed(4));
      html.style.setProperty('--orn-p700', Math.min(1, y / 700).toFixed(4));
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  } else if (reduce && !sdt) {
    html.classList.add('orn-no-sdt');
  }

  if (reduce) return; // everything below is decorative motion

  /* ---------- Count-up for live numbers (final value is already in the HTML) ---------- */
  function countUp(el) {
    var to = parseFloat(el.getAttribute('data-orn-count')), dec = (el.getAttribute('data-orn-count').split('.')[1] || '').length, t0 = null;
    if (isNaN(to)) return;
    function step(t) { if (t0 === null) t0 = t; var k = Math.min(1, (t - t0) / 1400), e = 1 - Math.pow(1 - k, 3); el.textContent = (to * e).toFixed(dec); if (k < 1) requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }
  ORN.counts = function (root) {
    var els = (root || d).querySelectorAll('[data-orn-count]:not([data-orn-done])');
    if (!('IntersectionObserver' in window)) return;
    var cio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.setAttribute('data-orn-done', ''); cio.unobserve(e.target); countUp(e.target); } }); }, { threshold: 0.6 });
    els.forEach(function (el) { cio.observe(el); });
  };
  ORN.counts();

  /* ---------- Page tint while a toned section crosses the middle of the screen (homepage) ---------- */
  var toned = d.querySelectorAll('[data-orn-tone]');
  if (toned.length && d.body.classList.contains('template-index')) {
    d.body.classList.add('orn-toning');
    var tTick = false;
    var tone = function () {
      tTick = false;
      var mid = window.innerHeight / 2, c = '';
      toned.forEach(function (s) { var r = s.getBoundingClientRect(); if (r.top < mid && r.bottom > mid) c = s.getAttribute('data-orn-tone'); });
      if (d.body.style.backgroundColor !== c) d.body.style.backgroundColor = c;
    };
    window.addEventListener('scroll', function () { if (!tTick) { tTick = true; requestAnimationFrame(tone); } }, { passive: true });
    tone();
  }

  /* ---------- Cart count bump + fly-to-cart ---------- */
  function cartIcon() { return [].slice.call(d.querySelectorAll('.header__icon-touch[href$="/cart"], [data-js-cart-icon]')).filter(function (x) { return x.offsetParent !== null; })[0]; }
  d.querySelectorAll('[data-js-cart-count]').forEach(function (el) {
    var last = el.textContent;
    new MutationObserver(function () {
      if (el.textContent === last) return;
      last = el.textContent;
      if (el.animate) el.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.6)' }, { transform: 'scale(1)' }], { duration: 450, easing: 'cubic-bezier(.2,.7,.1,1)' });
    }).observe(el, { childList: true, characterData: true, subtree: true });
  });
  var flySrc = null, flyAt = 0;
  d.addEventListener('pointerdown', function (e) {
    var t = e.target instanceof Element ? e.target : null;
    var card = t && t.closest('.product-item, .orn-look, .product__info-container, [data-orn-fly]');
    if (card && t.closest('button, [type="submit"], .quick-add, [data-orn-look]')) { flySrc = card; flyAt = Date.now(); }
  }, true);
  function fly() {
    if (!flySrc || Date.now() - flyAt > 6000) return;
    var src = flySrc; flySrc = null;
    var cart = cartIcon(), img = src.querySelector('img');
    if (!cart || !img || !img.animate) return;
    var a = img.getBoundingClientRect(), b = cart.getBoundingClientRect();
    if (!a.width) return;
    var g = d.createElement('div');
    g.setAttribute('aria-hidden', 'true');
    g.style.cssText = 'position:fixed;z-index:2147481000;pointer-events:none;left:' + a.left + 'px;top:' + a.top + 'px;width:' + a.width + 'px;height:' + a.height + 'px;border-radius:6px;background:#efe4cc url("' + (img.currentSrc || img.src) + '") center/cover;box-shadow:0 20px 40px rgba(37,24,17,.25)';
    d.body.appendChild(g);
    var tx = b.left + b.width / 2 - (a.left + a.width / 2), ty = b.top + b.height / 2 - (a.top + a.height / 2);
    g.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1, borderRadius: '6px' },
      { transform: 'translate(' + tx * 0.55 + 'px,' + (ty * 0.55 - 120) + 'px) scale(.45)', opacity: 1, offset: 0.55 },
      { transform: 'translate(' + tx + 'px,' + ty + 'px) scale(.06)', opacity: 0.4, borderRadius: '50%' }
    ], { duration: 850, easing: 'cubic-bezier(.5,0,.3,1)' }).onfinish = function () { g.remove(); };
  }
  ['cart:item-added', 'apps:product-added-to-cart'].forEach(function (n) { d.addEventListener(n, fly); window.addEventListener(n, fly); });

  /* ---------- Filled buttons: ripple on press; magnetic pull on fine pointers ---------- */
  var CTA = '.orn-btn--primary, .orn-price-card__go, .footer__newsletter-button, .orn-home-wa__btn, [data-orn-magnet]';
  d.addEventListener('pointerdown', function (e) {
    var el = e.target instanceof Element ? e.target.closest(CTA) : null;
    if (!el) return;
    var r = el.getBoundingClientRect(), s = Math.max(r.width, r.height) * 2.2;
    if (getComputedStyle(el).position === 'static') el.style.position = 'relative';
    el.style.overflow = 'hidden';
    var rp = d.createElement('span');
    rp.className = 'orn-ripple';
    rp.style.cssText = 'width:' + s + 'px;height:' + s + 'px;left:' + (e.clientX - r.left - s / 2) + 'px;top:' + (e.clientY - r.top - s / 2) + 'px';
    el.appendChild(rp);
    setTimeout(function () { rp.remove(); }, 750);
  });
  if (fine) {
    var magEl = null;
    d.addEventListener('pointermove', function (e) {
      var el = e.target instanceof Element ? e.target.closest(CTA) : null;
      if (magEl && magEl !== el) { magEl.style.translate = ''; magEl = null; }
      if (!el) return;
      var r = el.getBoundingClientRect();
      if (r.width > 420) return;
      magEl = el;
      el.style.transition = 'translate .35s cubic-bezier(.2,.7,.1,1), background-color .15s, color .15s, border-color .15s';
      el.style.translate = ((e.clientX - r.left - r.width / 2) * 0.22).toFixed(1) + 'px ' + ((e.clientY - r.top - r.height / 2) * 0.3).toFixed(1) + 'px';
    }, { passive: true });
  }

  /* Custom cursor + footer wordmark spotlight: assets/ornamint-fx.js (loaded only when the setting is on) */
})();

/* ---------- Lazy-image shimmer only near the viewport (see ornamint-site.css): marks .animation--lazy-load wrappers that
   are within 600 px of the screen with .orn-near; picks up cards added later (filters, infinite scroll) ---------- */
(function () {
  if (!('IntersectionObserver' in window)) { document.documentElement.classList.add('orn-near-all'); return; }
  var io = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.classList.toggle('orn-near', e.isIntersecting); }); }, { rootMargin: '600px 0px' });
  var seen = typeof WeakSet === 'function' ? new WeakSet() : null;
  function scan() { document.querySelectorAll('.animation--lazy-load:not(.loaded)').forEach(function (el) { if (seen && seen.has(el)) return; if (seen) seen.add(el); io.observe(el); }); }
  scan();
  var t = 0;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 200); }).observe(document.body, { childList: true, subtree: true });
})();

/* ---------- Sticky Back to top: appears after 600 px, smooth scroll (instant with reduced motion), then focus the logo.
   Lifts itself above anything else fixed in the bottom-right corner (chat widgets, cookie banners, sticky add-to-cart). ---------- */
(function () {
  var btn = document.querySelector('[data-orn-top-fixed]');
  if (!btn) return;
  var d = document, html = d.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var shown = false, ticking = false;
  var dock = d.querySelector('[data-orn-top-dock]'), docked = false;
  // Something else fixed at the bottom, overlapping the button's column: lift the button above its top edge
  function lift() {
    var vh = window.innerHeight, b = btn.getBoundingClientRect(), need = 0;
    var cands = [].slice.call(d.body.children).concat([].slice.call(d.querySelectorAll('#shopify-pc__banner, .shopify-pc__banner__dialog, [class*="sticky-atc"], [class*="sticky-add"], [data-sticky-atc], .product__sticky, iframe')));
    cands.forEach(function (el) {
      if (el === btn || el.contains(btn) || el.classList.contains('orn-intro')) return;
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
      if (cs.display === 'none' || cs.visibility === 'hidden' || +cs.opacity === 0) return;
      var r = el.getBoundingClientRect();
      if (r.width < 1 || r.height < 1 || r.height > vh * 0.6) return;     // ignore full-screen overlays (drawers, modals)
      if (r.bottom < vh - 160 || r.top > vh) return;                       // only things on the bottom edge
      if (r.right < b.left - 8 || r.left > b.right + 8) return;            // only things in the button's column
      need = Math.max(need, vh - r.top + 12 - 24);
    });
    html.style.setProperty('--orn-top-lift', Math.max(0, Math.round(need)) + 'px');
  }
  // Dock: once the footer's slot reaches the button's floating position, the button travels with the page and sits in the
  // slot (scroll-linked, so there is no jump; identical with reduced motion). The slot reserves the button's width.
  // The dock test uses the button's resting place WITHOUT the lift (a sticky add-to-cart bar may lift it), so the slot is
  // always reached at the bottom of the page on every template. The lift and the show / hide motion are both in 'translate'
  // (no layout shift); subtracting the current translate gives the resting place.
  function placeDock() {
    if (!dock) return false;
    if (dock.offsetWidth !== btn.offsetWidth) dock.style.setProperty('--orn-dock-w', btn.offsetWidth + 'px');
    btn.style.transform = '';
    var b = btn.getBoundingClientRect(), r = dock.getBoundingClientRect();
    var restTop = b.top - (parseFloat(getComputedStyle(btn).translate.split(' ')[1]) || 0);
    var on = r.height > 0 && r.top < restTop;
    btn.classList.toggle('is-docked', on);
    // b.top already includes the current translate (lift / show motion): move by the remaining distance to the slot
    if (on) btn.style.transform = 'translateY(' + Math.round(r.top - b.top) + 'px)';
    return on && r.top < window.innerHeight;
  }
  // Collision avoidance: while floating, the button steps out of the way (fades) wherever it would cover a footer link,
  // button, field or card, and comes back once clear or docked in its slot.
  var footer = d.querySelector('.shopify-section-group-footer-group') || d.querySelector('.footer');
  function obstacles() {
    if (!footer) return [];
    return [].slice.call(footer.querySelectorAll('a[href], button, input, select, textarea, .footer__group-content'))
      .filter(function (e) { return e !== btn && !btn.contains(e) && !e.closest('[data-orn-top-dock]'); });
  }
  function collides() {
    if (!footer || footer.getBoundingClientRect().top > window.innerHeight) return false;
    var b = btn.getBoundingClientRect(), m = 8, v = 48;   // look ahead vertically so it is gone before content reaches it
    return obstacles().some(function (e) {
      var r = e.getBoundingClientRect();
      return r.width > 0 && r.height > 0 && !(r.right <= b.left - m || r.left >= b.right + m || r.bottom <= b.top - v || r.top >= b.bottom + v);
    });
  }
  function update() {
    ticking = false;
    if (shown && !docked) lift();
    docked = placeDock();
    var want = docked || (window.scrollY || html.scrollTop) > 600 && d.body.getAttribute('mobile-menu-open') !== 'true' && d.body.getAttribute('quick-search-open') !== 'true';
    if (want !== shown) { shown = want; btn.classList.toggle('is-shown', want); btn.setAttribute('aria-hidden', want ? 'false' : 'true'); }
    var avoid = shown && !docked && collides();
    btn.classList.toggle('is-avoiding', avoid);
    btn.tabIndex = shown && !avoid ? 0 : -1;
  }
  var settle;
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } clearTimeout(settle); settle = setTimeout(function () { if (shown && !docked) lift(); }, 450); }, { passive: true });
  window.addEventListener('resize', update);
  // re-check when something else appears or slides in (sticky add-to-cart, cookie banner, chat widgets)
  if (window.MutationObserver) new MutationObserver(function () { if (shown && !docked) { clearTimeout(settle); settle = setTimeout(lift, 120); } }).observe(d.body, { childList: true, subtree: false, attributes: true, attributeFilter: ['class', 'style'] });
  d.addEventListener('transitionend', function (e) { if (shown && !docked && e.target instanceof Element && getComputedStyle(e.target).position === 'fixed') lift(); }, true);
  setInterval(function () { if (shown && !docked) lift(); }, 1500);   // cookie banners / chat widgets can appear later
  update();
  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    var target = d.querySelector('.header__row-desktop .header__logo-link, .header__logo-link');
    target = [].slice.call(d.querySelectorAll('.header__logo-link')).filter(function (x) { return x.offsetParent !== null; })[0] || target;
    var focusTop = function () { if (target) target.focus({ preventScroll: true }); };
    if (reduce || !('onscrollend' in window)) setTimeout(focusTop, reduce ? 0 : 800);
    else window.addEventListener('scrollend', focusTop, { once: true });
  });
})();

/* ---------- Header dropdowns: centred under their item, nudged back inside the page container if they would overflow ---------- */
(function () {
  var d = document;
  function place(panel) {
    if (!panel) return;
    var li = panel.closest('li'), row = panel.closest('.header__row-desktop');
    var trig = li && li.querySelector('[data-meganav-trigger]');
    if (row && trig) { var rr = row.getBoundingClientRect(), tr = trig.getBoundingClientRect(); panel.style.setProperty('--orn-x', Math.round(tr.left + tr.width / 2 - rr.left) + 'px'); }
    panel.style.setProperty('--orn-nudge', '0px');
    var r = panel.getBoundingClientRect();
    if (!r.width) return;
    var cs = getComputedStyle(d.documentElement);
    var edge = parseFloat(getComputedStyle(d.querySelector('.header__inner')).paddingLeft) || 0;
    var minL = edge, maxR = d.documentElement.clientWidth - edge, n = 0;
    if (r.right > maxR) n = maxR - r.right;
    if (r.left + n < minL) n = minL - r.left;
    panel.style.setProperty('--orn-nudge', Math.round(n) + 'px');
  }
  function watch() {
    d.querySelectorAll('.header__row-desktop [data-meganav-trigger]').forEach(function (t) {
      if (t.__ornPlace) return;
      t.__ornPlace = true;
      new MutationObserver(function () { if (t.getAttribute('aria-expanded') === 'true') place(t.closest('li').querySelector('.meganav')); }).observe(t, { attributes: true, attributeFilter: ['aria-expanded'] });
    });
  }
  watch();
  window.addEventListener('resize', function () { d.querySelectorAll('.header__row-desktop [data-meganav-trigger][aria-expanded="true"]').forEach(function (t) { place(t.closest('li').querySelector('.meganav')); }); });
  d.addEventListener('shopify:section:load', watch);
})();

